module.exports = __webpack_public_path__ + "img/idx-title-download.ae0d498.webp";